﻿import { AdpVoucherPrintStatus, DonationType } from '../enums/index';
import { IAdpVoucherHolder } from './adp-voucher-holder';

export interface IAdpDonor {
    id: number;
    alias: string;
    donationDate: string;
    registrationDate: string;
    name: string;
    firstName: string;
    lastName: string;
    status: string;
    donationType: DonationType,
    donationTypeAbbr: string,
    adpCertPrintDate: Date;
    adpCertPrintUserId: number;
    adpCertFirstCheckUserId: number;
    adpCertSecondCheckUserId: number;
    printStatus: AdpVoucherPrintStatus;
    voucherHolders: IAdpVoucherHolder[];
    hasVoucherHoldersToSend: boolean;
    isComplete: boolean;
    hasDonated: boolean;
}
